var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v(_vm._s(_vm.title))]),
      _c(
        "md-layout",
        { staticClass: "space-x" },
        [
          _c(
            "md-layout",
            [
              _c(
                "md-input-container",
                { class: { "md-input-invalid": _vm.nameError } },
                [
                  _c("label", [_vm._v("Name")]),
                  _c("md-input", {
                    attrs: { maxlength: 50 },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.addCredit.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.newCredit.name,
                      callback: function($$v) {
                        _vm.$set(_vm.newCredit, "name", $$v)
                      },
                      expression: "newCredit.name"
                    }
                  }),
                  _vm.nameError
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v("Name is required")
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "md-layout",
            [
              _c(
                "md-input-container",
                [
                  _c("label", [_vm._v("Role")]),
                  _c(
                    "md-select",
                    {
                      model: {
                        value: _vm.newCredit.role,
                        callback: function($$v) {
                          _vm.$set(_vm.newCredit, "role", $$v)
                        },
                        expression: "newCredit.role"
                      }
                    },
                    _vm._l(_vm.roles, function(role) {
                      return _c(
                        "md-option",
                        { key: role.value, attrs: { value: role.value } },
                        [_vm._v(_vm._s(role.label))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "md-layout",
            { staticClass: "add-btn-container", attrs: { "md-flex": "5" } },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-icon-button md-primary md-mini md-dense",
                  on: { click: _vm.addCredit }
                },
                [_c("md-icon", { attrs: { "md-iconset": "fa fa-plus" } })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.entity.credits && _vm.entity.credits.length
        ? _c(
            "md-list",
            { staticClass: "credits-list" },
            _vm._l(_vm.entity.credits, function(credit, index) {
              return _c(
                "md-list-item",
                { key: index, staticClass: "p-0" },
                [
                  _c("div", { staticClass: "credit-info" }, [
                    _c("span", { staticClass: "credit-name" }, [
                      _vm._v(_vm._s(credit.name))
                    ]),
                    _c("span", { staticClass: "credit-role" }, [
                      _vm._v(_vm._s(_vm.getRoleLabel(credit.role)))
                    ])
                  ]),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button md-primary",
                      on: {
                        click: function($event) {
                          return _vm.removeCredit(index)
                        }
                      }
                    },
                    [_c("md-icon", { attrs: { "md-iconset": "fa fa-trash" } })],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb4d2d38", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb4d2d38","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/CreditsForm.vue
// module id = 940
// module chunks = 0